import React from 'react'

import { Helmet } from 'react-helmet'

import StoreBanner from '../components/store-banner'
import './home.css'
import Footer from '../components/footer'

const Terms = (props) => {
  return (
    <div className="home-container10">
      <Helmet>
        <title>Ismailishq</title>
        <meta property="og:title" content="Ismailishq" />
      </Helmet>
      <div data-role="Header" className="home-header-container">
        <header className="home-header">
          <div className="home-logo1">
            <a href="https://ismailishq.com">
              <img
                alt="image"
                src="/logotype-dark.svg"
                className="home-image10"
              />
            </a>
          </div>
          <div className="home-menu1 modern-nav">
            <a href="/terms" className='modern-nav-link'><span className="home-text47" >Terms</span></a>
            <a href="/help" className='modern-nav-link'><span className="home-text48">Help</span></a>
            <a href="/privacy-policy" className='modern-nav-link'><span className="home-text49" href="/privacy-policy">Privacy Policy</span></a>
          </div>
          <div className="home-container11">
            <StoreBanner></StoreBanner>
          </div>
          <div data-role="BurgerMenu" className="home-burger-menu">
            <svg viewBox="0 0 1024 1024" className="home-menu2">
              <path d="M810.667 725.333h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"></path>
              <path d="M810.667 426.667h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"></path>
              <path d="M810.667 128h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"></path>
            </svg>
          </div>
        </header>
        <div data-role="MobileMenu" className="home-mobile-menu">
          <div className="home-top">
            <div className="home-logo2">
              <img
                alt="image"
                src="/logotype-dark.svg"
                className="home-image11"
              />
            </div>
            <div data-role="CloseMobileMenu" className="home-close-menu">
              <svg viewBox="0 0 1024 1024" className="home-icon15">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="home-mid">
            <a href="/terms"><span className="home-text47" >Terms</span></a>
            <a href="/help"><span className="home-text48">Help</span></a>
            <a href="/privacy-policy"><span className="home-text49" href="/privacy-policy">Privacy Policy</span></a>
          </div>
          <div className="home-bot">
            <div className="home-container12">
                            <a
                href="https://www.instagram.com/ismaili_ishq?igsh=MXFueDViMHY2ODBmYw=="
                target="_blank"
                rel="noreferrer noopener"
                className="home-link5"
              >
                <div className="home-container38">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="home-icon25"
                  >
                    <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
                  </svg>
                </div>
              </a>
              <a
                href="https://www.facebook.com/share/1afcYdBjxE/?mibextid=wwXIfr"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link6"
              >
              <div className="home-container39">
                <svg
                  viewBox="0 0 24 24"
                  className="home-icon25"
                >
                  <path d="M23.9981 11.9991C23.9981 5.37216 18.626 0 11.9991 0C5.37216 0 0 5.37216 0 11.9991C0 17.9882 4.38789 22.9522 10.1242 23.8524V15.4676H7.07758V11.9991H10.1242V9.35553C10.1242 6.34826 11.9156 4.68714 14.6564 4.68714C15.9692 4.68714 17.3424 4.92149 17.3424 4.92149V7.87439H15.8294C14.3388 7.87439 13.8739 8.79933 13.8739 9.74824V11.9991H17.2018L16.6698 15.4676H13.8739V23.8524C19.6103 22.9522 23.9981 17.9882 23.9981 11.9991Z" /></svg>
              </div>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link7 hidden"
              >
                <div className="home-container40">
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="home-icon29"
                  >
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                </div>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link8 hidden"
              >
                <div className="home-container41">
                  <svg viewBox="0 0 1024 1024" className="home-icon31">
                    <path d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s0.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-0.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z"></path>
                  </svg>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="terms-wrapper">
        <div className="terms-content">
          <h1 className="terms-title">Terms of Service</h1>

          <section className="terms-section">
            <h2 className="terms-section-title">Acceptance</h2>
            <p>
              Upon accessing, viewing and using the Application, you are going to be legally bound by these Terms, serving as a binding contractual commitment between you and Ismailishq. While we do our very best to monitor the Ismailishq community, it’s always best to use your judgment when interacting with people on or off the app. Our team is there to help make your experience as enjoyable and comfortable as possible.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">Restrictions</h2>
            <p>
              Registering for an account (“Account”) you must: Be at least 18 years old; and Be legally permitted to use the App by the laws of your home country. Have never been convicted of or pled no contest to a felony, a sex crime, or any crime involving violence, and that you are not required to register as a sex offender with any state, federal or local sex offender registry.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">Account</h2>
            <p>
              Account creation is done using your Facebook login details. When creating an Account using your Facebook login details, you authorize Ismailishq to access, display and use certain information from your Facebook account (e.g. profile pictures, relationship status, location, education, work, and information about Facebook friends). Complete acknowledgment that sharing your Facebook profile details will be shown on Ismailishq. [...] Immediately contact us at info@ismailishq.me if you become aware of any unauthorized use of your password or any other breach of security.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">Account Deletion</h2>
            <p>
              You may delete your account by accessing the “settings” section of the application. If you are a monthly subscriber to Ismailishq, you will need to manage your in-app purchase through your mobile device platform (iTunes, Google Play) to cancel paid subscriptions.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">License, Restrictions & Rights Ismailishq Grants You</h2>
            <p>
              Ismailishq grants you a personal, worldwide, revocable, limited, non-transferable license to use the features and functions of the Service. You agree to comply with all applicable laws, and not to misuse or abuse the platform. [...] The Company may investigate and take any available legal action in response to illegal and/or unauthorized uses.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">Content</h2>
            <p>
              Content that is offensive, harassing, abusive, obscene, or otherwise violates our community guidelines will not be permitted. [...] We reserve the right to remove, edit, limit or block access to any of Your Content at any time.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">Other Users’ Content</h2>
            <p>
              Other members of Ismailishq will also share content via the App. You do not have any rights to other users’ Member Content beyond what's necessary for interaction. Misuse of user information may result in account termination.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">Ismailishq’s Content</h2>
            <p>
              All proprietary content on Ismailishq, including logos, trademarks, artwork, and UI, is protected under applicable intellectual property laws.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">Purchases</h2>
            <p>
              In-app purchases are handled through your respective platform's store (iTunes, Google Play). Subscription renewals and billing are managed through your store account. Deleting the Ismailishq app does not cancel your subscription.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">Refunds</h2>
            <p>
              For Apple users: request refunds through iTunes. For Google Play users: contact us through the app with your order number.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">Interactions with other Users</h2>
            <p>
              Ismailishq does not conduct criminal background checks. Interactions are your responsibility, and you agree to exercise caution when connecting with others.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">Push Notifications; Location Based Features</h2>
            <p>
              You may receive push notifications and location-based content depending on your settings. To opt-out, adjust your mobile settings accordingly.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">Disclaimer</h2>
            <p>
              The Ismailishq App and services are provided “as is” without warranties. We disclaim all implied warranties to the maximum extent permitted by law.
            </p>
          </section>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Terms
